import { render, staticRenderFns } from "./Gathering.vue?vue&type=template&id=239891a8&scoped=true&"
import script from "./Gathering.vue?vue&type=script&lang=js&"
export * from "./Gathering.vue?vue&type=script&lang=js&"
import style0 from "./Gathering.vue?vue&type=style&index=0&id=239891a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239891a8",
  null
  
)

export default component.exports